module.exports = __webpack_public_path__ + "img/circle-3.204a4658.png";